module.exports = "pegasus/assets/cloud-card.png";